import JSZip from "jszip";
import * as XLSX from "xlsx";

export interface IPstRow {
    raID: string;
    nameoftheRA: string;
    tso: string;
    availibility: string;
    preventive: string;
    curative: string;
    timeFrom: string;
    timeTo: string;
    timestamp: number;
    rangeFrom: number;
    rangeTo: number;
    craRangeFrom: string;
    craRangeTo: string;
    pstGroupID: string;
    enforcedRA: string;
    afterCoList: string;
    pstDescriptionMode: string;
    nodeFrom: string;
    nodeTo: string;
    orderCode: string;
    downwardsRange: number;
    downwardsRangeManual: boolean;
    upwardsRange: number;
    upwardsRangeManual: boolean;
    initialCGM?: number;
}

const strTimestampToNumber = (timestamp: string) => {
    return parseInt(timestamp.substring(0, 2));
};

const mapRowToPstRow = (row: any) => {
    let mappedRows: IPstRow[] = [];
    const timeFrom = strTimestampToNumber(row["Time From"]);
    const timeTo = strTimestampToNumber(row["Time To"]);

    for (let timestamp = timeFrom; timestamp < timeTo; timestamp++) {
        const mappedRow: IPstRow = {
            nameoftheRA: row["Name of the RA"],
            rangeFrom: row["Range_From"],
            rangeTo: row["Range_To"],
            downwardsRange: row["Downwards Range"],
            upwardsRange: row["Upwards Range"],
            timeFrom: row["Time From"],
            timeTo: row["Time To"],
            timestamp: timestamp,
            nodeFrom: row["UCT Node From"],
            nodeTo: row["UCT Node To"],
            orderCode: row["Order Code / Element Name"],
            raID: row["RA ID"],
            tso: row["TSO"],
            availibility: row["Availibility"],
            preventive: row["Preventive"],
            curative: row["Curative"],
            craRangeFrom: row["CRA Relative range_From"],
            craRangeTo: row["CRA Relative range_To"],
            pstGroupID: row["PST group ID"],
            enforcedRA: row["Enforced RA?"],
            afterCoList: row["AfterCO list"],
            pstDescriptionMode: row["PST description mode"],
            downwardsRangeManual: false,
            upwardsRangeManual: false,
        };
        mappedRows.push(mappedRow);
    }
    return mappedRows;
};

export const mapPstToExcelRow = (pst: IPstRow) => {
    const excelRow = {
        "RA ID": pst.raID,
        "Name of the RA": pst.nameoftheRA,
        TSO: pst.tso,
        Availibility: pst.availibility,
        Preventive: pst.preventive,
        Curative: pst.curative,
        "Time From": pst.timeFrom,
        "Time To": pst.timeTo,
        Range_From: pst.rangeFrom,
        Range_To: pst.rangeTo,
        "CRA Relative range_From": pst.craRangeFrom,
        "CRA Relative range_To": pst.craRangeTo,
        "PST group ID": pst.pstGroupID,
        "Enforced RA?": pst.enforcedRA,
        "AfterCO list": pst.afterCoList,
        "PST description mode": Number.isNaN(parseInt(pst.orderCode)) ? "ElementName" : "OrderCode",
        "UCT Node From": pst.nodeFrom,
        "UCT Node To": pst.nodeTo,
        "Order Code / Element Name": pst.orderCode,
        "Downwards Range": pst.downwardsRange,
        "Upwards Range": pst.upwardsRange,
    };
    return excelRow;
};

export const applyFilter = (rows: IPstRow[], activeTimestamps: number[]) => {
    if (!rows) return [];
    rows = rows.filter(x => activeTimestamps.includes(x.timestamp));
    return rows;
};

export const parseExcelFromZip = async (zipFile: File) => {
    const zip = await JSZip.loadAsync(zipFile);
    let filename: string | undefined;
    filename = Object.keys(zip.files).find(f => f.endsWith(".xlsx") && f.includes("MODIFIED"));
    if (!filename) filename = Object.keys(zip.files).find(f => f.endsWith(".xlsx"));
    if (filename === undefined) return;

    const blob = await zip.file(filename)!.async("blob");
    const workbook = XLSX.read(await blob.arrayBuffer());
    let rows = XLSX.utils.sheet_to_json(workbook.Sheets["PST"]);
    return rows.map(x => mapRowToPstRow(x)).flat();
};
